import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchProject(params) {
  return await request({
    url: ENDPOINT.PROJECT,
    method: "get",
    params,
  });
}

export async function fetchProjectById(id) {
  return await request({
    url: `${ENDPOINT.PROJECT}/${id}`,
    method: "get",
  });
}

export async function createProject(data) {
  return await request({
    url: ENDPOINT.PROJECT,
    method: "post",
    data,
  });
}

export async function updateProject(id, data) {
  return await request({
    url: `${ENDPOINT.PROJECT}/${id}`,
    method: "put",
    data,
  });
}

export async function deleteProject(id) {
  return await request({
    url: `${ENDPOINT.PROJECT}/${id}`,
    method: "delete",
  });
}